import queryString from 'query-string';

declare global {
  var serverUrl: URL;
}

export const AUTH_ROUTES = {
  LOGIN: '/auth/login/',
  REGISTER: '/auth/signup/',
  LOGOUT: '/auth/logout/',
};

export const LOGGED_IN_PARAM = 'loggedIn';

export const getLoginUrl = ({
  baseUrl,
  returnTo,
  showRegister,
}: {
  baseUrl?: string;
  returnTo?: string;
  showRegister?: boolean;
} = {}) =>
  queryString.stringifyUrl({
    url: showRegister ? AUTH_ROUTES.REGISTER : AUTH_ROUTES.LOGIN,
    query: {
      returnTo:
        returnTo ||
        queryString.stringifyUrl({
          url:
            typeof window === 'undefined'
              ? // We should have `serverUrl` set in SSR.
                global.serverUrl.href
              : baseUrl || window.location.href,
          query: {
            [LOGGED_IN_PARAM]: true,
          },
        }),
    },
  });
